import { render, staticRenderFns } from "./AwardRankingSection.vue?vue&type=template&id=1422e5cf&scoped=true"
import script from "./AwardRankingSection.vue?vue&type=script&lang=ts"
export * from "./AwardRankingSection.vue?vue&type=script&lang=ts"
import style0 from "./AwardRankingSection.vue?vue&type=style&index=0&id=1422e5cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422e5cf",
  null
  
)

export default component.exports